import { defineStore } from 'pinia';
import { strapi } from '~/stores/transport/strapi';
import { assignDataToFields } from '~/utils/strapiComponents/addStrapiData';

export const useStoreModalDepositStatus = defineStore('modalDepositStatus', {
  state: () => ({
    fiatSuccessTitle: '',
    fiatSuccessDetailText: '',
    fiatFailTitle: '',
    fiatFailDetailText: '',
    locale: '',
    requestPromise: null as Promise<any> | null,
  }),

  actions: {
    async loadDepositStatusModal() {
      if (!this.requestPromise) {
        this.requestPromise = strapi()
          .get('deposit-status-modal')
          .finally(() => (this.requestPromise = null));
      }

      const response = await this.requestPromise;

      if (response?.data) {
        assignDataToFields(this, response.data);

        return true;
      } else {
        return false;
      }
    },
  },
});
